// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"videos_scrollbar__3DnwY"};